/** Pure navigation rules shared by the desktop sidebar and the mobile tab bar. */

/** Which tab is current. App detail pages are drill-downs from Overzicht, so they keep that tab lit. */
export function isTabActive(to: string, path: string): boolean {
  if (to === "/") return path === "/" || path.startsWith("/apps/");
  return path === to || path.startsWith(`${to}/`);
}

/** Open/close rules for the mobile search bar. */
export type SearchEvent = "toggle" | "navigate" | "escape" | "submit";

export function nextSearchOpen(open: boolean, event: SearchEvent): boolean {
  return event === "toggle" ? !open : false;
}
